(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("WebCrypto", [], factory);
	else if(typeof exports === 'object')
		exports["WebCrypto"] = factory();
	else
		root["WebCrypto"] = factory();
})(self, () => {
return 